import { gql } from '@apollo/client';

export const GRADO_MILITAR_FRAGMENT = gql`
  fragment GradoMilitarFields on GradoMilitar {
    id
    codigo
    nombre
    descripcion
    precio_noche
    precio_noche_temporal
    orden
    activo
    created_at
    updated_at
  }
`;

export const GET_GRADOS_MILITARES = gql`
  query GetGradosMilitares($activo: Boolean) {
    gradosMilitares(activo: $activo) {
      ...GradoMilitarFields
    }
  }
  ${GRADO_MILITAR_FRAGMENT}
`;

export const GET_GRADO_MILITAR = gql`
  query GetGradoMilitar($id: Int!) {
    gradoMilitar(id: $id) {
      ...GradoMilitarFields
    }
  }
  ${GRADO_MILITAR_FRAGMENT}
`;

export const CREAR_GRADO_MILITAR = gql`
  mutation CrearGradoMilitar($input: CrearGradoMilitarInput!) {
    crearGradoMilitar(input: $input) {
      ...GradoMilitarFields
    }
  }
  ${GRADO_MILITAR_FRAGMENT}
`;

export const ACTUALIZAR_GRADO_MILITAR = gql`
  mutation ActualizarGradoMilitar($id: Int!, $input: ActualizarGradoMilitarInput!) {
    actualizarGradoMilitar(id: $id, input: $input) {
      ...GradoMilitarFields
    }
  }
  ${GRADO_MILITAR_FRAGMENT}
`;

export const ELIMINAR_GRADO_MILITAR = gql`
  mutation EliminarGradoMilitar($id: Int!) {
    eliminarGradoMilitar(id: $id)
  }
`;
